/* src/helpers/displayFieldRenderers.js */
/* eslint-disable */

import React from "react";
import { TextField, Typography } from "@material-ui/core";
import GridItem from "components/Grid/GridItem";
import ReactSelect from "react-select";
import { getAltLabel } from "utils/getAltLabel";

/*──────────────────────────────────────────────────────────────────────┤
   P R O P S
   ─ data      → objeto “selectedInitiative”
   ─ classes   → JSS (mesmo que você já usa)
   ─ t         → i18next
───────────────────────────────────────────────────────────────────────*/

/*=====================================================================*/
/*  Ⅰ.  IDENTIFICATION                                                 */
/*=====================================================================*/
const InitiativeId = ({ data, classes, t }) => (
  <GridItem xs={12} sm={2} style={{ marginBottom: 10 }}>
    <TextField
      disabled fullWidth
      label={t("new_initiatives.fields.initiative_id")}
      value={data.id_internal || ""}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ readOnly: true, classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText } }}
    />
  </GridItem>
);

const InitiativeName = ({ data, classes, t, userDetails }) => (
  <GridItem xs={12} sm={10} style={{ marginBottom: 10 }}>
    <TextField
      disabled fullWidth
      label={getAltLabel("new_initiatives.fields.initiative_name", userDetails, t)}
      value={data.initiative || ""}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ readOnly: true, classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText } }}
    />
  </GridItem>
);

/* ---- Branch & Workfront ------------------------------------------ */
const BranchField = ({ data, classes, t, userDetails }) => (
  <GridItem xs={12} sm={6} style={{ marginBottom: 14 }}>
    <TextField
      disabled fullWidth
      label={getAltLabel("new_initiatives.fields.branch", userDetails, t)}
      value={data.branch || ""}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ readOnly: true, classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText } }}
    />
  </GridItem>
);

const WorkfrontField = ({ data, classes, t, userDetails }) => (
  <GridItem xs={12} sm={6} style={{ marginBottom: 14 }}>
    <TextField
      disabled fullWidth
      label={getAltLabel("new_initiatives.fields.workfront", userDetails, t)}
      value={data.workfront || ""}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ readOnly: true, classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText } }}
    />
  </GridItem>
);

/* ---- Leader & PMO ------------------------------------------------- */
const LeaderField = ({ data, classes, t, userDetails }) => (
  <GridItem xs={12} sm={6} style={{ marginBottom: 10 }}>
    <TextField
      disabled fullWidth
      label={getAltLabel("new_initiatives.fields.initiative_leader", userDetails, t)}
      value={data.leader || ""}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ readOnly: true, classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText } }}
    />
  </GridItem>
);

const Leader2Field = ({ data, classes, t, userDetails }) => (
  <GridItem xs={12} sm={6} style={{ marginBottom: 10 }}>
    <TextField
      disabled fullWidth
      label={getAltLabel("new_initiatives.fields.initiative_leader_2", userDetails, t)}
      value={data.leader2 || ""}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ readOnly: true, classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText } }}
    />
  </GridItem>
);

const PmoField = ({ data, classes, t, userDetails }) => (
  <GridItem xs={12} sm={6} style={{ marginBottom: 10 }}>
    <TextField
      disabled fullWidth
      label={getAltLabel("new_initiatives.fields.initiative_pmo", userDetails, t)}
      value={data.pmo || ""}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ readOnly: true, classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText } }}
    />
  </GridItem>
);

/*=====================================================================*/
/*  Ⅱ.  DATES                                                          */
/*=====================================================================*/
const buildDateField = (key, labelKey) =>
  function DateDisplay({ data, classes, t }) {
    return (
      <GridItem xs={12} sm={3} style={{ marginBottom: 10 }}>
        <TextField
          disabled fullWidth type="date"
          label={t(`new_initiatives.fields.${labelKey}`)}
          value={data[key] || ""}
          InputProps={{ readOnly: true, classes: { input: classes.inputText } }}
          InputLabelProps={{ shrink: true, classes: { root: classes.labelText } }}
          classes={{ root: classes.textFieldRoot }}
        />
      </GridItem>
    );
  };

const ImpStartDate   = buildDateField("imp_start_date",   "imp_start_date");
const ImpEndDate     = buildDateField("imp_end_date",     "imp_end_date");
const ResultsStart   = buildDateField("results_start_date","results_start_date");
const ResultsEnd     = buildDateField("results_end_date", "results_end_date");

/*=====================================================================*/
/*  Ⅲ.  DESCRIPTION & RISKS                                            */
/*=====================================================================*/
const DescriptionField = ({ data, classes, t }) => (
  <GridItem xs={12} sm={12} style={{ marginBottom: 10 }}>
    <TextField
      disabled fullWidth multiline rows={4}
      label={t("new_initiatives.fields.description")}
      value={data.description || ""}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ readOnly: true, classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText }, shrink: true }}
    />
  </GridItem>
);

const RisksField = ({ data, classes, t }) => (
  <GridItem xs={12} sm={12} style={{ marginBottom: 10 }}>
    <TextField
      disabled fullWidth multiline rows={4}
      label={t("new_initiatives.fields.risks")}
      value={data.risks || ""}
      classes={{ root: classes.textFieldRoot }}
      InputProps={{ readOnly: true, classes: { input: classes.inputText } }}
      InputLabelProps={{ classes: { root: classes.labelText }, shrink: true }}
    />
  </GridItem>
);

/*=====================================================================*/
/*  Ⅳ.  CLASSIFICATION FIELDS (lista simples)                          */
/*=====================================================================*/
const listToString = (arr) =>
  Array.isArray(arr) && arr.length ? arr.join("; ") : "–";

const toSelect = (arr) =>
  Array.isArray(arr) ? arr.map((v) => ({ label: v, value: v })) : [];


const TagsField = ({ data, classes, t, customStyles, userDetails }) => (
  <GridItem xs={12} sm={6}>
    <div className={classes.multiSelectContainer}>
      <label className={classes.labelMultiSelect}>
        {getAltLabel("new_initiatives.fields.tags", userDetails, t)}
      </label>
      <ReactSelect
        isMulti
        isDisabled
        value={toSelect(data.tags)}
        styles={customStyles}
      />
    </div>
  </GridItem>
);

const AccessGroupField = ({ data, classes, t, customStyles }) => (
  <GridItem xs={12} sm={6}>
    <div className={classes.multiSelectContainer}>
      <label className={classes.labelMultiSelect}>
        {t("new_initiatives.fields.access_group")}
      </label>
      <ReactSelect
        isMulti
        isDisabled
        value={toSelect(data.accessGroups)}
        styles={customStyles}
      />
    </div>
  </GridItem>
);

const ImpactField = ({ data, classes, t, customStyles }) => (
  <GridItem xs={12} sm={6}>
    <div className={classes.multiSelectContainer}>
      <label className={classes.labelMultiSelect}>
        {t("new_initiatives.fields.initiative_impact")}
      </label>
      <ReactSelect
        isMulti
        isDisabled
        value={toSelect(data.initiativeImpacts)}
        styles={customStyles}
      />
    </div>
  </GridItem>
);

/*=====================================================================*/
/*  Ⅴ.  EDITORS (e-mails separados por “; ”)                           */
/*=====================================================================*/

const buildEditorsField = (key, labelKey) =>
  function EditorsDisplay({ data, classes, t, customStyles }) {
    return (
      <GridItem xs={12} sm={6}>
        <div className={classes.multiSelectContainer}>
          <label className={classes.labelMultiSelect}>
            {t(`new_initiatives.fields.${labelKey}`)}
          </label>
          <ReactSelect
            isMulti
            isDisabled
            value={toSelect(data.editors?.[key] || [])}
            styles={customStyles}
          />
        </div>
      </GridItem>
    );
  };

const EditorsOnePage  = buildEditorsField("one_page",       "editors_one_page");
const EditorsImp      = buildEditorsField("implementation", "editors_imp");
const EditorsResults  = buildEditorsField("results",        "editors_results");

/*=====================================================================*/
/*  E X P O R T  – “registry”                                          */
/*=====================================================================*/
export const displayFieldRenderers = {
  /* Identification */
  initiativeId: InitiativeId,
  initiativeName: InitiativeName,
  branch: BranchField,
  workfront: WorkfrontField,
  initiativeLeader: LeaderField,
  initiativeLeader2: Leader2Field,
  initiativePmo: PmoField,

  /* Dates */
  impStartDate: ImpStartDate,
  impEndDate: ImpEndDate,
  resultsStartDate: ResultsStart,
  resultsEndDate: ResultsEnd,

  /* Description & Risks */
  description: DescriptionField,
  risks: RisksField,

  /* Classification */
  tags: TagsField,
  accessGroup: AccessGroupField,
  initiativeImpact: ImpactField,

  /* Editors */
  editors_one_page: EditorsOnePage,
  editors_implementation: EditorsImp,
  editors_results: EditorsResults,
};
